import styled from 'styled-components';

const FullHeightWrapper = styled.div`
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const S = { FullHeightWrapper };
